import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import PhonelinkIcon from '@mui/icons-material/PhonelinkTwoTone';
import { NavItemProps } from '../types';

import styles from '../NavigationBarItem.module.css';

const motorCityRelayLink = 'https://relay.motorcity.systems/';

export default function MotorCityRelayListItem({ isDesktopOpen, isMobile }: NavItemProps) {
  return (
    <ListItem
      disablePadding
      className={styles['navigation-item']}
      title='Motorcity Relay'>
      <ListItemButton
        component='a'
        href={motorCityRelayLink}
        target='_blank'
        rel='noopener noreferrer'
        className={styles['navigation-item-btn']}>
        <ListItemIcon className={styles['navigation-item-btn-icon']}>
          <PhonelinkIcon />
        </ListItemIcon>
        <ListItemText
          primary='Motorcity Relay'
          slotProps={{
            primary: {
              className: `${styles['navigation-item-btn-text']} ${!isDesktopOpen && !isMobile ? styles.hidden : ''}`,
              variant: 'body1'
            }
          }}
        />
      </ListItemButton>
    </ListItem>
  );
}
